import { cx } from "shared/utils";
import { BoomCrmPaywall } from "./BoomCrmPaywall";
import { PageSkeleton } from "./PageSkeleton";
import { PAYWALL_COPY, type PaywallFeature } from "./constants";

interface PaywalledPanelProps {
  feature: PaywallFeature;
  /** Sizing for the host slot, e.g. a min-height so the blurred bg has room. */
  className?: string;
}

/**
 * The paywall card centered over a blurred page skeleton, for surfaces that
 * lock only PART of a page (an analytics tab, a settings slice) and so cannot
 * use `PaywallScreen`, which owns the whole route. Without the skeleton the card
 * floats on a blank panel and reads as an empty state (QA on CRM-759).
 */
export const PaywalledPanel = ({ feature, className }: PaywalledPanelProps) => (
  <div className={cx("relative w-full overflow-hidden", className)}>
    <div className="pointer-events-none select-none" aria-hidden="true">
      <PageSkeleton feature={feature} />
    </div>
    <div
      className="absolute inset-0 z-10 flex items-center justify-center p-4"
      style={{
        backgroundColor: "rgba(255,255,255,0.1)",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)"
      }}
    >
      <BoomCrmPaywall {...PAYWALL_COPY[feature]} />
    </div>
  </div>
);
